import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const GMKMetropolis = () => (
  <ArticleWrapper articleId="gmk_metropolis">
    <div className="min-h-screen bg-[#111112] flex flex-col w-full">
      <div className="prose prose-invert mx-auto p-6">
        <h1>GMK Metropolis</h1>
        {/* Add your GMK Metropolis article content here */}
        <p>This is a placeholder article for the GMK Metropolis keycap set. More content coming soon.</p>
      </div>
    </div>
  </ArticleWrapper>
);

export default GMKMetropolis;
